import { ServerMessagePayload } from '@common/api';
import { SoundEvent } from '@common/events';

import { ClientEventSystem } from './ClientBase';

export class SoundSystem extends ClientEventSystem<'SoundEvent'> {
  public eventTypes: 'SoundEvent'[] = ['SoundEvent'];

  handleEvent(event: SoundEvent): ServerMessagePayload[] {
    console.log(`Playing sound: ${event.payload.soundName}`);
    const audio = new Audio(`/assets/${event.payload.soundName}`);
    audio.volume = 0.1;
    audio.play().catch((e) => {
      console.error(`Failed to play sound ${event.payload.soundName}:`, e);
    });
    return [];
  }
}
